import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin'
import MANAGE_FAMILY_CONST from '@/constants/ManageFamilyConst'
import applicationStore from '@/store/modules/applications/applicationStore'
import APP_UTILITIES from '@/utilities/commonFunctions'
import APP_CONST from '@/constants/AppConst'
import AccountSettings from '@/mixins/accountSettings.mixin'
import DropdownListBx from '@/ui-components/dropdownListBx/DropdownList.vue'
import { IDropdownConfig } from '@/Model/model'
import { ScreenText } from '@/lang/ScreenText'
import InviteLink from '@/commoncomponents/inviteLink/InviteLink.vue'
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue'
import commonEntry from '@/store/modules/commonEntry'
import { ScholarContactType } from '@/Model/user/types'

@Component({
  components: {
    BouncingPreloader,
    dropdown: DropdownListBx,
    'invite-link': InviteLink
  }
})
export default class ScholarDetails extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  public scholarInfoHeader: any = MANAGE_FAMILY_CONST.ScholarInfoHeader
  public enrollmentStatusHeader: any = MANAGE_FAMILY_CONST.EnrollmentStatusHeader
  public emergencyContactHeader: any = MANAGE_FAMILY_CONST.EmargencyContactHeader
  public schoalrDetailsObj: any = []
  public allFieldsRequired: boolean = false
  schoalrDetails: any = 'abcdefghijklmnopqrstuvwxyz'
  private birthDateFormatErr: boolean = false
  private onSubmit: boolean = false
  private birthDateErrorType: string = ''
  private firstNameErrorText: string = ''
  private lastNameErrorText: string = ''
  private firstNameGurdianErrorText: string = ''
  private lastNameGurdianErrorText: string = ''
  private states: string[] = APP_UTILITIES.getStatesShortFinalList(APP_CONST.COUNTRY_ID)
  private gradesList: { id: string; value: string }[] = MANAGE_FAMILY_CONST.GradesList
  public indexValGaurdian: number = -1
  public openCloseGaurdian: boolean = false
  public activeGuardianLength: number = 0
  public editEmergencyDetailsLength: number = 0
  public disableDelete: boolean = false
  public disableIndex: number = -1
  public emergencyIsActive: boolean = true
  public gaurdiansActive: boolean = true
  public scholarInfoActive: boolean = true
  public emergencyFirstIndex: number = -1
  public guardianFirstIndex: number = -1
  public dropValues: { id: string; value: string }[] = [
    { id: 'Yes', value: 'Yes' },
    { id: 'No', value: 'No' }
  ]
  public dropdownConfig: IDropdownConfig = MANAGE_FAMILY_CONST.DROPDOWN_CONFIG
  public objScreenText: ScreenText = new ScreenText()
  public inputTypes: string[] = MANAGE_FAMILY_CONST.INPUTTYPES
  public isSubmitted: boolean = false
  public isBannerShow: boolean = false
  public noOfErrors: any = []
  public positionofError: number = 0
  public disablePrevButton: boolean = false
  public disableNextButton: boolean = false
  public nextPreviousButtonCalled: boolean = false
  public dropdownTypes: string[] = ['select', 'dropdown']
  public outsideClick: boolean = false
  public isRedBannerShown: boolean = false
  public isEmergencyDetailsPresent: boolean = false
  public readonly ScholarContactType = ScholarContactType

  scholarInformation: any = {
    firstName: 'John',
    lastName: 'Wisley',
    nickName: 'Jo',
    birthDate: '01-02-2011',
    age: 10,
    gender: 'Male',
    ethnicity: 'Fair',
    emailId: 'john.wisley@greenmail.com',
    phoneNumber: '1547896321',
    phoneType: 'Cell',
    address: 'New Mery Corna Road, Block No. 2035, Jeden, Werty',
    schoolName: 'New English Public School, Jeden, Werty',
    schoolStudentId: 'BRYT-548976',
    allergies: 'NA',
    epiPen: 'NA',
    asthmaInhaler: 'NA',
    medications: 'NA',
    insuranceProvider: 'MDH Corp. Pvt. Ltd'
  }
  guardianInformation: any = [
    {
      firstName: 'Isa',
      lastName: 'Wisley',
      relationToChild: 'Mother',
      email: 'isawisley@heatmail.com',
      primaryPhoneNumber: '2879461601',
      primaryPhoneType: 'Cell',
      secondaryPhoneNumber: '7894-561230',
      secondaryPhoneType: 'Land Line',
      address: 'New Mery Corna Road, Block No. 2035, Jeden, Werty',
      languagesAtHome: 'Spanish, Japanese, English'
    },
    {
      firstName: 'Thomos',
      lastName: 'Wisley',
      relationToChild: 'Father',
      email: 'thomoswisley@heatmail.com',
      primaryPhoneNumber: '7894561601',
      primaryPhoneType: 'Cell',
      secondaryPhoneNumber: '7894-561230',
      secondaryPhoneType: 'Land Line',
      address: 'New Mery Corna Road, Block No. 2035, Jeden, Werty',
      languagesAtHome: 'Spanish, Japanese, English'
    }
  ]
  emergencyDetails: any = [
    {
      callOrder: 1,
      firstName: 'Isa',
      lastName: 'Wisley',
      relationToChild: 'Mother',
      phoneNumber: '2879461601',
      phoneType: 'Cell'
    },
    {
      callOrder: 2,
      firstName: 'Thomos',
      lastName: 'Wisley',
      relationToChild: 'Father',
      phoneNumber: '7894561601',
      phoneType: 'Cell'
    }
  ]
  medicalFields: any = ['allergies', 'epiPen', 'asthmaInhaler', 'medication', 'insuranceProvider']
  scholarLearningFields: string[] = ['iep', 'llp', 'specialEducation']

  @Prop() response!: any

  public getScreenText(key: string): string {
    return this.objScreenText.getScreenText(key)
  }

  get phoneTypes() {
    const phoneTypes = MANAGE_FAMILY_CONST.PhoneTypes
    return phoneTypes
  }

  get selectedScholar() {
    return applicationStore.selectedScholar
  }

  get isProgramDetailsByScholarLoading() {
    return applicationStore.isProgramDetailsByScholarLoading
  }

  get isLoadingGetAddedScholarData() {
    return applicationStore.isLoadingGetAddedScholarData
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor
  }

  get editMode() {
    return applicationStore.isFormEditModeActive
  }

  get isEmergencyContactsExists() {
    return this.selectedScholar &&
      this.selectedScholar.emergencyContacts &&
      this.selectedScholar.emergencyContacts.length
      ? true
      : false
  }

  get editScholarDetails() {
    return applicationStore.scholarDetails
  }

  get editGuardianDetails() {
    return applicationStore.guardianDetails
  }

  get editAuthorizePickups() {
    return applicationStore.authorizeDetails
  }

  get editEmergencyDetails() {
    return applicationStore.emergencyDetails
  }

  get duplicateErrorResponse() {
    return applicationStore.duplicateUsersResponse
  }

  get duplicateFirstName() {
    return this.duplicateErrorResponse ? this.duplicateErrorResponse.firstName : ''
  }

  get duplicateLastName() {
    return this.duplicateErrorResponse ? this.duplicateErrorResponse.lastName : ''
  }

  get callOrders() {
    const callOrders = MANAGE_FAMILY_CONST.CallOrdersList
    return callOrders
  }

  get scholarInfoContainError() {
    let error = false
    this.editScholarDetails.forEach((scholarInfo: any) => {
      error =
        (scholarInfo.firstName.alphaCharError ||
        (scholarInfo.firstName.errorStatus && scholarInfo.firstName.value.length === 0)
          ? true
          : scholarInfo.firstName.alphaCharError || this.firstNameErrorText != ''
            ? true
            : false) ||
        (scholarInfo.lastName.alphaCharError ||
        (scholarInfo.lastName.errorStatus && scholarInfo.lastName.value.length === 0)
          ? true
          : scholarInfo.lastName.alphaCharError || this.lastNameErrorText != ''
            ? true
            : false) ||
        this.birthDateFormatErr ||
        (scholarInfo.birthDate.errorStatus && scholarInfo.birthDate.value.length < 14) ||
        (scholarInfo.email.value && this.validateEmail(scholarInfo.email.value) ? true : false) ||
        (scholarInfo.zip.value && scholarInfo.zip.value.length < 5 ? true : false)
    })
    return error
  }

  get guardianInfoContainError() {
    let error: boolean = false
    for (let i = 0; i < this.editGuardianDetails.length; i++) {
      if (this.editGuardianDetails[i].status.value != 3) {
        error =
          (this.editGuardianDetails[i].firstName.alphaCharError ||
          (this.editGuardianDetails[i].firstName.errorStatus &&
            this.editGuardianDetails[i].firstName.value.length === 0)
            ? true
            : this.editGuardianDetails[i].firstName.alphaCharError
              ? true
              : false) ||
          (this.editGuardianDetails[i].lastName.alphaCharError ||
          (this.editGuardianDetails[i].lastName.errorStatus &&
            this.editGuardianDetails[i].lastName.value.length === 0)
            ? true
            : this.editGuardianDetails[i].lastName.alphaCharError
              ? true
              : false) ||
          (this.editGuardianDetails[i].email.errorStatus &&
          this.editGuardianDetails[i].email.value.length == 0
            ? true
            : this.validateEmail(this.editGuardianDetails[i].email.value, i)
              ? true
              : false) ||
          (this.editGuardianDetails[i].phone.value.length == 0 &&
          this.editGuardianDetails[i].phone.errorStatus
            ? true
            : false) ||
          (this.editGuardianDetails[i].zip.value && this.editGuardianDetails[i].zip.value.length < 5
            ? true
            : false) ||
          (this.duplicateErrorResponse &&
          this.checkDuplicateUser(this.editGuardianDetails[i]) &&
          this.duplicateErrorResponse.guid != this.editGuardianDetails[i].guid.value
            ? true
            : false) ||
          (this.editGuardianDetails[i].lastName.duplicateErrorStatus ? true : false)

        if (error == true) {
          break
        }
      }
    }
    return error
  }

  get emergencyInfoContainError() {
    let error = false
    for (let i = 0; i < this.editEmergencyDetails.length; i++) {
      if (this.editEmergencyDetails[i].status.value != 3) {
        error =
          (this.editEmergencyDetails[i].firstName.alphaCharError ||
          (this.editEmergencyDetails[i].firstName.errorStatus &&
            this.editEmergencyDetails[i].firstName.value.length === 0)
            ? true
            : this.editEmergencyDetails[i].firstName.alphaCharError
              ? true
              : false) ||
          (this.editEmergencyDetails[i].lastName.alphaCharError ||
          (this.editEmergencyDetails[i].lastName.errorStatus &&
            this.editEmergencyDetails[i].lastName.value.length === 0)
            ? true
            : this.editEmergencyDetails[i].lastName.alphaCharError
              ? true
              : false) ||
          (this.editEmergencyDetails[i].phone.value.length == 0 &&
          this.editEmergencyDetails[i].phone.errorStatus
            ? true
            : false) ||
          (this.editEmergencyDetails[i].lastName.duplicateErrorStatus ? true : false)

        if (error == true) {
          break
        }
      }
    }
    return error
  }

  formatNumber(phoneNumber: string) {
    const phoneCheck = phoneNumber && APP_UTILITIES.formatPhoneNumberWithBracket(phoneNumber)

    if (phoneCheck) {
      return phoneNumber && APP_UTILITIES.formatPhoneNumberWithBracket(phoneNumber)
    }
    return phoneNumber
  }

  isCallOrderAlreadyExists(callOrder: any, index: number) {
    let isExists = false
    if (callOrder) {
      if (
        this.editEmergencyDetails[index] &&
        this.editEmergencyDetails[index].callOrder &&
        this.editEmergencyDetails[index].callOrder.value != callOrder
      ) {
        isExists = true
      }
    }
    return isExists
  }

  checkDuplicateUser(scholarInfo: any) {
    return (
      scholarInfo.firstName.value == this.duplicateFirstName &&
      scholarInfo.lastName.value == this.duplicateLastName
    )
  }

  getScholarInfo(key: string) {
    if (this.medicalFields.includes(key)) {
      return this.selectedScholar && this.selectedScholar.scholarMedical
        ? this.selectedScholar.scholarMedical[key]
        : ''
    } else if (key == 'ethnicity') {
      return this.selectedScholar && this.selectedScholar.raceEthnicity
        ? this.selectedScholar.raceEthnicity
        : ''
    } else if (key == 'address') {
      return this.selectedScholar && this.selectedScholar.address
        ? this.getFullAddress(this.selectedScholar.address)
        : ''
    } else if (key == 'phone') {
      return this.selectedScholar && this.selectedScholar.phone
        ? this.formatNumber(this.selectedScholar.phone)
        : ''
    } else if (this.scholarLearningFields.includes(key)) {
      return this.selectedScholar && this.selectedScholar.scholarLearning
        ? this.selectedScholar.scholarLearning[key]
        : ''
    } else {
      return this.selectedScholar ? this.selectedScholar[key] : ''
    }
  }

  onlyNumber($event: any) {
    const keyCode = $event.keyCode ? $event.keyCode : $event.which
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      $event.preventDefault()
    }
  }

  openDropdown(index: number, type: string, details: string) {
    if (details == this.ScholarContactType.EMERGENCY_CONTACT) {
      if (this.editEmergencyDetails) {
        this.editEmergencyDetails[index][type].dropStatus = true
      }
    }
  }

  selectList(index: number, type: string, details: string, list: string) {
    list = list && list == 'Select' ? '' : list
    if (details === this.ScholarContactType.GUARDIAN) {
      this.editGuardianDetails[index][type].value = list
      this.editGuardianDetails[index][type].dropStatus = false
    } else if (details === this.ScholarContactType.EMERGENCY_CONTACT) {
      const temp = this.editEmergencyDetails[index][type].value
      this.editEmergencyDetails[index][type].value = list
      if (type == 'callOrder') {
        for (let i = 0; i < this.editEmergencyDetails.length; i++) {
          if (this.editEmergencyDetails[i].callOrder.value == list && index != i) {
            this.editEmergencyDetails[i].callOrder.value = temp
          }
        }
      }
      this.editEmergencyDetails[index][type].dropStatus = false
    } else {
      this.editScholarDetails[APP_CONST.ZERO][type].value = list
      this.editScholarDetails[APP_CONST.ZERO][type].dropStatus = false
    }
  }

  validateForm() {
    let isInvalid = false
    this.isBannerShow = false
    this.editScholarDetails[APP_CONST.ZERO].birthDate.errorStatus = false
    if (!this.editScholarDetails[APP_CONST.ZERO].firstName.value) {
      this.editScholarDetails[APP_CONST.ZERO].firstName.errorStatus = true
      isInvalid = true
    }
    if (!this.editScholarDetails[APP_CONST.ZERO].lastName.value) {
      this.editScholarDetails[APP_CONST.ZERO].lastName.errorStatus = true
      isInvalid = true
    }
    if (!this.editScholarDetails[APP_CONST.ZERO].birthDate.value) {
      this.editScholarDetails[APP_CONST.ZERO].birthDate.errorStatus = true
      isInvalid = true
    }

    this.editGuardianDetails.forEach((guardian: any, index: number) => {
      if (!guardian.firstName.value) {
        guardian.firstName.errorStatus = true
        isInvalid = true
      }
      if (!guardian.lastName.value) {
        guardian.lastName.errorStatus = true
        isInvalid = true
      }
      if (guardian.primaryGuardian && guardian.primaryGuardian.value && !guardian.email.value) {
        guardian.email.errorStatus = true
        isInvalid = true
      }
      if (!guardian.phone.value) {
        guardian.phone.errorStatus = true
        isInvalid = true
      }
    })

    this.editEmergencyDetails.forEach((emergency: any, index: number) => {
      emergency.firstName.alphaCharError = false
      emergency.lastName.alphaCharError = false
      emergency.firstName.errorStatus = false
      emergency.lastName.errorStatus = false
      emergency.phone.errorStatus = false
      if (
        !emergency.firstName.value &&
        (emergency.lastName.value || emergency.phone.value || emergency.relation.value)
      ) {
        emergency.firstName.errorStatus = true
        isInvalid = true
      }
      if (
        !emergency.lastName.value &&
        (emergency.firstName.value || emergency.phone.value || emergency.relation.value)
      ) {
        emergency.lastName.errorStatus = true
        isInvalid = true
      }
      if (emergency.phone.value.length == 1 && emergency.phone.value == '(') {
        emergency.phone.value = ''
      }
      if (
        !emergency.phone.value &&
        (emergency.firstName.value || emergency.lastName.value || emergency.relation.value)
      ) {
        emergency.phone.errorStatus = true
        isInvalid = true
      }
    })
    this.validationsCheck('firstName')
    if (isInvalid || !this.validateEmail() || this.validateRecord()) {
      setTimeout(() => {
        const inputdoc: any = document.querySelectorAll('.outline-red')
        this.noOfErrors = inputdoc
        this.isBannerShow = true
        this.isRedBannerShown = false
        this.movetoFirstError()
      }, 300)
    }

    return isInvalid
  }

  validateRecord(dataDetails?: any, fields?: any, includeIndex?: boolean) {
    let duplicateErrorStatus: boolean = false
    if (dataDetails) {
      dataDetails.forEach((data: any, currentIndex: number) => {
        const currentFirstName = data.firstName.value ? data.firstName.value.toLowerCase() : ''
        const currentLastName = data.lastName.value ? data.lastName.value.toLowerCase() : ''
        if (this.inputTypes.includes(fields.input)) {
          if (
            fields.firstName &&
            fields.lastName &&
            currentFirstName == fields.firstName &&
            currentLastName == fields.lastName &&
            (!includeIndex || (includeIndex && currentIndex != fields.elemIndex))
          ) {
            if (!duplicateErrorStatus && data.status.value != 3) {
              duplicateErrorStatus = true
            }
          }
        }
      })
    }
    return duplicateErrorStatus
  }

  validateAllRecords(
    recordDetails: any,
    input: string,
    type: ScholarContactType,
    inputType?: string
  ) {
    let duplicateFirstErrorStatus: boolean = false
    let duplicateSecondErrorStatus: boolean = false
    let duplicateThirdErrorStatus: boolean = false

    if (recordDetails) {
      recordDetails.forEach((userData: any, currentIndex: number) => {
        userData.firstName.duplicateErrorStatus = false
        userData.lastName.duplicateErrorStatus = false
        const firstName = userData.firstName.value ? userData.firstName.value.toLowerCase() : ''
        const lastName = userData.lastName.value ? userData.lastName.value.toLowerCase() : ''
        switch (type) {
          case this.ScholarContactType.GUARDIAN:
            duplicateFirstErrorStatus = this.validateRecord(
              this.editGuardianDetails,
              { firstName, lastName, input, elemIndex: currentIndex },
              type == this.ScholarContactType.GUARDIAN ? true : false
            )
            if (duplicateFirstErrorStatus) {
              userData.lastName.duplicateErrorMessage = APP_CONST.DUPLICATE_GUARDIAN_RECORD
            }
            break
          case this.ScholarContactType.EMERGENCY_CONTACT:
            duplicateSecondErrorStatus = this.validateRecord(
              this.editEmergencyDetails,
              { firstName, lastName, input, elemIndex: currentIndex },
              type == this.ScholarContactType.EMERGENCY_CONTACT ? true : false
            )
            if (duplicateSecondErrorStatus) {
              userData.lastName.duplicateErrorMessage = APP_CONST.DUPLICATE_EMERGENCY_RECORD
            }
            break
          case this.ScholarContactType.AUTHORIZED_PICKUP:
            duplicateThirdErrorStatus = this.validateRecord(
              this.editAuthorizePickups,
              { firstName, lastName, input, elemIndex: currentIndex },
              type == this.ScholarContactType.AUTHORIZED_PICKUP ? true : false
            )
            if (duplicateThirdErrorStatus) {
              userData.lastName.duplicateErrorMessage = APP_CONST.DUPLICATE_AUTHORIZED_RECORD
            }
            break
          default:
            break
        }
        if (
          (duplicateFirstErrorStatus && userData.status.value != 3) ||
          (duplicateSecondErrorStatus && userData.status.value != 3) ||
          (duplicateThirdErrorStatus && userData.status.value != 3)
        ) {
          userData.firstName.duplicateErrorStatus = true
          userData.lastName.duplicateErrorStatus = true
        }
      })
    }
  }

  validationsCheck(input: string, inputType?: string) {
    this.validateAllRecords(
      this.editGuardianDetails,
      input,
      this.ScholarContactType.GUARDIAN,
      inputType
    )
    this.validateAllRecords(
      this.editEmergencyDetails,
      input,
      this.ScholarContactType.EMERGENCY_CONTACT,
      inputType
    )
    this.validateAllRecords(
      this.editAuthorizePickups,
      input,
      this.ScholarContactType.AUTHORIZED_PICKUP,
      inputType
    )
  }

  public scholarValidation(
    userObj: any,
    input: string,
    event: any,
    type?: ScholarContactType,
    index?: number
  ) {
    const key = event.key
    const name = userObj.value
    if (
      type == this.ScholarContactType.EMERGENCY_CONTACT &&
      (index || index == 0) &&
      this.editEmergencyDetails[index].firstName.value == '' &&
      this.editEmergencyDetails[index].lastName.value == '' &&
      (this.editEmergencyDetails[index].phone.value == '' ||
        this.editEmergencyDetails[index].phone.value == '(')
    ) {
      this.isEmergencyDetailsPresent = false
      this.editEmergencyDetails[index].firstName.errorStatus = false
      this.editEmergencyDetails[index].lastName.errorStatus = false
      this.editEmergencyDetails[index].phone.errorStatus = false
    } else {
      this.isEmergencyDetailsPresent = true
    }
    if (this.isEmergencyDetailsPresent) {
      if (userObj.value == '' || (input == 'phone' && userObj.value == '(')) {
        userObj.errorStatus = true
      } else {
        userObj.errorStatus = false
      }
    }
    for (let i = 0; i < name.length; i++) {
      const numberCheck = APP_UTILITIES.hasOnlyAlphabetDotSpace(name)
      if (!numberCheck && !input.includes('phone')) {
        userObj.alphaCharError = true
        return
      }
      userObj.alphaCharError = false
    }
    if (key == 'Backspace') {
      userObj.alphaCharError = false
    }
    this.validationsCheck(input, type)
  }

  validateEmail(mail?: string, index?: number) {
    if (mail) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(mail) ? false : true
    } else {
      return false
    }
  }

  getPhoneNumber(value: string) {
    const values = APP_UTILITIES.removeSpecialCharacters(value)
    return values
  }

  addEmergencyContact() {
    this.emergencyIsActive = true
    if (!this.editMode) {
      applicationStore.mutateEditFormMode(true)
      if (this.isEmergencyContactsExists) {
        applicationStore.mutateNewEmergency()
      }
    } else {
      applicationStore.mutateNewEmergency()
    }
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_DETAILS.addedEmergencyContact)
  }

  addGuardian() {
    this.gaurdiansActive = true
    if (!this.editMode) {
      applicationStore.mutateEditFormMode(true)
    }
    applicationStore.mutateNewGuardian()
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_DETAILS.addedGuardian)
  }

  selectPrimaryGuardian(guardian: any, index: number, $event: any) {
    if (this.activeGuardianLength > 1) {
      this.editGuardianDetails[index].primaryGuardian.value =
        !this.editGuardianDetails[index].primaryGuardian.value
      if (index == this.guardianFirstIndex) {
        this.editGuardianDetails.forEach((guardian: any, ind: number) => {
          if (ind != this.guardianFirstIndex && guardian.status.value == 1) {
            guardian.primaryGuardian.value = !guardian.primaryGuardian.value
          }
        })
      } else if (index != this.guardianFirstIndex) {
        this.editGuardianDetails[this.guardianFirstIndex].primaryGuardian.value =
          !this.editGuardianDetails[this.guardianFirstIndex].primaryGuardian.value
      }
    } else {
      this.editGuardianDetails[index].primaryGuardian.value = true
    }
  }

  calculateAge(dateInput: any) {
    if (!this.birthDateFormatErr || !this.birthDateErrorType) {
      const today = new Date()
      let birthDate: any
      if (dateInput instanceof Date) {
        birthDate = dateInput
      } else {
        birthDate = new Date(dateInput.replace(/\s/g, '').replace(/-/g, '/'))
      }

      if (birthDate > today || birthDate.getFullYear() < 1900) {
        this.birthDateFormatErr = true
        this.birthDateErrorType = 'wrong year'
        return
      }
      let ageYear = today.getFullYear() - birthDate.getFullYear()
      const month = today.getMonth() - birthDate.getMonth()
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        ageYear--
      }
      this.editScholarDetails[APP_CONST.ZERO].age.value = ageYear
    }
  }

  onblurdate(e: any) {
    const input = typeof e == 'object' ? e.target.value : e

    const values = input.split('-').map(function (v: any, i: number) {
      return v.replace(/\D/g, '')
    })

    let inputDate = input.replace(/\s/g, '').replace(/-/g, '/')
    inputDate = new Date(inputDate)

    if (values.length == 3) {
      let year: number
      const month = parseInt(values[0]) - 1
      const day = parseInt(values[1])
      if (
        values[2].length !== 4 ||
        (values[2].length == 4 && (parseInt(values[2]) < 1900 || inputDate > new Date()))
      ) {
        this.birthDateFormatErr = true
        this.birthDateErrorType = 'wrong year'
      } else {
        this.birthDateFormatErr = false
        this.birthDateErrorType = ''
        year = parseInt(values[2])

        if (values[0].length == 2 && values[1].length == 2) {
          this.birthDateFormatErr = !this.isValidDate(year, month, day)
          this.birthDateErrorType = this.birthDateFormatErr ? 'Invalid Date' : ''
        } else {
          this.birthDateFormatErr = true
        }
      }
    } else {
      this.birthDateFormatErr = true
    }
  }

  isValidDate(year: number, month: number, day: number) {
    const d = new Date(year, month, day)

    if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
      return true
    }
    return false
  }

  birthDateChanges(dateVal: string, event: any, index: number, type: string) {
    if (event.key == 'Backspace') {
      if (type == 'birthDate') {
        this.birthDateFormatErr = true
      }
    } else {
      if (type == 'birthDate') {
        this.birthDateFormatErr = false
      }
    }

    if (dateVal.length > 0) {
      const birthDay = this.dateOnChange(event, index, type)
      if (dateVal.length == 14 && type == 'birthDate') {
        this.calculateAge(birthDay)
      } else {
        if (type == 'birthDate' && dateVal.length < 14) {
          this.editScholarDetails[APP_CONST.ZERO].age.value = ''
        }
      }
    }
  }

  dateOnChange(e: any, index: number, type: string) {
    const dateElement: any = document.querySelector(`#${type}_${index}`)
    let input =
      this.editScholarDetails && this.editScholarDetails[index]
        ? this.editScholarDetails[index][type].value
        : ''

    if (/\D\/$/.test(input)) {
      input = input.substr(0, input.length - 3)
    }

    const checkLength = input.split('-').map(function (v: any) {
      return v.replace(/\D/g, '')
    })

    if (checkLength.length < 3 && checkLength[checkLength.length - 1].length > 2) {
      input = [input.slice(0, input.length - 1) + ' - ', input.slice(input.length - 1)].join('')
    }

    const values = input.split('-').map(function (v: any) {
      return v.replace(/\D/g, '')
    })

    if (values[0]) {
      values[0] = this.checkValue(values[0], 12, true)
    }

    if (values[1]) {
      values[1] = this.checkValue(values[1], 31, false)
    }

    const output = values.map(function (v: any, i: any) {
      return v.length == 2 && i < 2 ? v + ' - ' : v
    })

    let dateFormat = output.join('').substr(0, 14)

    if (
      e.key == 'Backspace' &&
      (dateFormat.substr(dateFormat.length - 1) == '-' ||
        dateFormat.substr(dateFormat.length - 1) == ' ')
    ) {
      dateFormat = dateFormat.substr(0, dateFormat.length - 4)
    }

    dateElement.value = dateFormat
    return dateFormat
  }

  checkValue(str: string, max: number, month: boolean) {
    if (str.charAt(0) !== '0' || str == '00') {
      let num = parseInt(str)
      if (isNaN(num) || num <= 0 || num > max) {
        num = parseInt(num.toString().charAt(0))
      }
      if (month) {
        str =
          num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
            ? '0' + num
            : num.toString()
      } else {
        str =
          num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
            ? ''
            : num.toString()
        if (str == '') {
          str = 0 + num.toString()
        }
      }
    }
    return str
  }

  getFullAddress(address: any) {
    let fullAddress: any = ''
    if (address && address.address1) {
      fullAddress = fullAddress + address.address1 + ', '
    }
    if (address && address.address2) {
      fullAddress = fullAddress + address.address2 + ', '
    }
    if (address && address.city) {
      fullAddress = fullAddress + address.city + ', '
    }
    if (address && address.state) {
      fullAddress = fullAddress + address.state + ', '
    }
    if (address && address.zip) {
      fullAddress = fullAddress + address.zip
    }
    return fullAddress
  }

  destroyed() {
    applicationStore.mutateEditFormMode(false)
  }

  openCloseDeleteConfirm(index: any, type: string) {
    if (type == 'gaurdian') {
      if (this.indexValGaurdian == index) {
        this.openCloseGaurdian = false
        this.indexValGaurdian = -1
      } else {
        this.indexValGaurdian = index
        this.openCloseGaurdian = true
      }
    }
  }

  cancelChanges() {
    this.openCloseGaurdian = false
  }

  removeFinal(data: any, index: any, type: any) {
    if (type == 'gaurdian') {
      const activeLength = this.activeGuardianLength
      applicationStore.mutateDeleteGaurdianFields({ data, index, activeLength })
      if (
        activeLength == 1 &&
        this.editGuardianDetails[this.editGuardianDetails.length - 1].status.value == 1
      ) {
        this.disableDelete = true
        this.disableIndex = this.editGuardianDetails.length - 1
      }
      if (data.primaryGuardian.value) {
        this.editGuardianDetails.forEach((guardian: any, ind: number) => {
          if (
            guardian.email.value != data.email.value &&
            guardian.status.value != 3 &&
            guardian.primaryGuardian.value == false
          ) {
            this.editGuardianDetails[ind].primaryGuardian.value = true
          }
        })
      }
      APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_DETAILS.deletedGuardian)
    } else if (type == 'emergencyContact') {
      const activeLength = this.editEmergencyDetailsLength
      applicationStore.mutateDeleteEmergencyContactsFields({ data, index, activeLength })
      APP_UTILITIES.segmentTrackEvent(
        APP_CONST.SEGMENT_EVENTS.SCHOLAR_DETAILS.deletedEmergencyContact
      )
    }

    this.validationsCheck('firstName')
  }

  @Watch('selectedScholar', { deep: true })
  checkCurrentScholarDetails(scholar: any) {
    if (scholar.guardianDetails) {
      this.activeGuardianLength = scholar.guardianDetails.length
    }
    if (scholar.emergencyContacts) {
      this.editEmergencyDetailsLength = scholar.emergencyContacts.length
    }
  }

  @Watch('editGuardianDetails', { deep: true })
  watchEditGuardianDetails(value: any) {
    const editGuardianDetailsWatch = value
    this.activeGuardianLength = 0
    let count = 0
    editGuardianDetailsWatch.forEach((ele: any, index: number) => {
      if (ele.status.value != 3 && count === 0) {
        this.guardianFirstIndex = index
        count++
      }
      if (ele.status.value != 3) {
        this.activeGuardianLength += 1
      }
    })

    if (this.disableIndex != -1 && this.disableDelete) {
      const val = editGuardianDetailsWatch[this.disableIndex]
      if (
        val.firstName.value ||
        val.lastName.value ||
        val.email.value ||
        val.phone.value ||
        val.relation.value ||
        val.phoneType.value ||
        val.secondaryPhone.value ||
        val.secondaryPhoneType.value ||
        val.address1.value ||
        val.address2.value ||
        val.city.value ||
        val.state.value ||
        val.homeLanguage.value
      ) {
        this.disableDelete = false
        this.editGuardianDetails[this.disableIndex].status.value = 1
      }
    }

    if (this.disableIndex != -1 && !this.disableDelete) {
      const val = editGuardianDetailsWatch[this.disableIndex]
      if (
        !val.firstName.value &&
        !val.lastName.value &&
        !val.email.value &&
        !val.phone.value &&
        !val.relation.value &&
        !val.phoneType.value &&
        !val.secondaryPhone.value &&
        !val.secondaryPhoneType.value &&
        !val.address1.value &&
        !val.address2.value &&
        !val.city.value &&
        !val.state.value &&
        !val.homeLanguage.value
      ) {
        this.disableDelete = true
        this.editGuardianDetails[this.disableIndex].status.value = ''
      }
    }
  }

  @Watch('editEmergencyDetails', { deep: true })
  watchEditEmergencyDetails(value: any) {
    const editEmergencyDetailsWatch = value
    this.editEmergencyDetailsLength = 0
    let count = 0
    editEmergencyDetailsWatch.forEach((ele: { status: { value: number } }, index: number) => {
      if (ele.status.value != 3 && count === 0) {
        this.emergencyFirstIndex = index
        count++
      }
      if (ele.status.value != 3) {
        this.editEmergencyDetailsLength += 1
      }
    })

    editEmergencyDetailsWatch.forEach((ele: any) => {
      if (
        ele.firstName.value ||
        ele.lastName.value ||
        ele.firstName.value ||
        ele.relation.value ||
        ele.phone.value ||
        ele.phoneType.value ||
        this.editEmergencyDetailsLength > APP_CONST.ONE
      ) {
        ele.disableDelete.value = false
      } else {
        ele.disableDelete.value = true
      }
    })
  }

  toggleEmergencyCons() {
    this.emergencyIsActive = !this.emergencyIsActive
  }

  toggleGaurdianDetails() {
    this.gaurdiansActive = !this.gaurdiansActive
  }

  toggleScholarInfo() {
    this.scholarInfoActive = !this.scholarInfoActive
  }

  syncLinksActivation() {
    if (this.selectedScholar.guardianDetails) {
      this.activeGuardianLength = this.selectedScholar.guardianDetails.length
    }
    if (this.selectedScholar.emergencyContacts) {
      this.editEmergencyDetailsLength = this.selectedScholar.emergencyContacts.length
    }
  }

  mounted() {
    const temp: any[] = []
    this.states.forEach((state) => {
      temp.push({ id: state, value: state })
    })
    this.states = temp
    this.syncLinksActivation()
    applicationStore.mutateEditProgramFormMode(true)
    applicationStore.mutateEditProgramFormMode(false)
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_DETAILS.viewedScholarDetails)
  }

  preLabel() {
    this.nextPreviousButtonCalled = true
    this.disablePrevButton = false
    this.disableNextButton = false
    const oldNumberOferrors = this.noOfErrors && this.noOfErrors.length
    this.noOfErrors = document.querySelectorAll('.outline-red')
      ? document.querySelectorAll('.outline-red')
      : ''

    let valuecheked: boolean = false
    const focussedElement: any = document.getElementsByClassName('error-outlined-banner')
    for (let index = 0; index < this.noOfErrors.length; index++) {
      if (this.noOfErrors[index] == focussedElement[0]) {
        this.positionofError = index + 1
        valuecheked = true
      }
    }

    if (
      oldNumberOferrors > this.noOfErrors.length &&
      this.noOfErrors.length < this.positionofError
    ) {
      const differenceBtwErrors = oldNumberOferrors - this.noOfErrors.length
      const currentPosition = this.positionofError - differenceBtwErrors
      this.positionofError = currentPosition <= 0 ? APP_CONST.ONE : currentPosition + 1
    }

    this.positionofError = valuecheked ? this.positionofError : this.positionofError - 1
    if (this.positionofError !== 0 && this.positionofError <= this.noOfErrors.length) {
      this.disablePrevButton = false
      this.positionofError = valuecheked ? this.positionofError - 1 : this.positionofError
      this.navigateToLabel(
        this.noOfErrors[this.positionofError - 1],
        this.noOfErrors[this.positionofError]
      )
    }
    if (this.positionofError == 1) {
      this.disablePrevButton = true
    }
  }

  nextLabel() {
    this.nextPreviousButtonCalled = true
    this.disableNextButton = false
    this.disablePrevButton = false
    let valuecheked: boolean = false
    this.noOfErrors = document.querySelectorAll('.outline-red')
      ? document.querySelectorAll('.outline-red')
      : ''
    const focussedElement: any = document.getElementsByClassName('error-outlined-banner')
    for (let index = 0; index < this.noOfErrors.length; index++) {
      if (this.noOfErrors[index] == focussedElement[0]) {
        this.positionofError = index + 1
        valuecheked = true
      }
    }
    if (this.positionofError - 1 <= this.noOfErrors.length - 1) {
      this.disableNextButton = false
      this.navigateToLabel(
        this.noOfErrors[valuecheked ? this.positionofError : this.positionofError - 1],
        this.noOfErrors[valuecheked ? this.positionofError - 1 : this.positionofError - 2]
      )
      this.positionofError = valuecheked ? this.positionofError + 1 : this.positionofError
    }
    if (this.positionofError == this.noOfErrors.length) {
      this.disableNextButton = true
    }
  }

  movetoFirstError() {
    this.disableNextButton = false
    this.disablePrevButton = true
    const inputdoc: any = document.querySelectorAll('.outline-red')
    inputdoc.forEach((element: any) => {
      element.classList.remove('error-outlined-banner')
    })
    this.noOfErrors = document.querySelectorAll('.outline-red')
      ? document.querySelectorAll('.outline-red')
      : ''
    this.navigateToLabel(this.noOfErrors[0])
    this.positionofError = APP_CONST.ONE
    if (this.noOfErrors.length == APP_CONST.ONE) {
      this.disableNextButton = true
    }
  }

  navigateToLabel(element: HTMLElement, lastelement?: HTMLElement) {
    if (element) {
      this.isRedBannerShown = true
      element.classList.add('error-outlined-banner')

      if (
        (element && element.className == 'scholar outline-red error-outlined-banner') ||
        (element && element.className == 'scholar outline-red postal-input error-outlined-banner')
      ) {
        this.scholarInfoActive = true
      }

      if (
        (element && element.className == 'guardianAcc outline-red error-outlined-banner') ||
        (element &&
          element.className == 'guardianAcc outline-red postal-input error-outlined-banner')
      ) {
        this.gaurdiansActive = true
      }

      if (element && element.className == 'emergencyAcc outline-red error-outlined-banner') {
        this.emergencyIsActive = true
      }

      setTimeout(() => {
        element && element.focus()
      }, 100)

      window.scrollBy({
        top:
          document.documentElement.clientWidth > 992
            ? element.getBoundingClientRect().top - 210
            : document.documentElement.clientWidth > 830
              ? element.getBoundingClientRect().top - 230
              : document.documentElement.clientWidth > 768
                ? element.getBoundingClientRect().top - 260
                : document.documentElement.clientWidth > 580
                  ? element.getBoundingClientRect().top - 260
                  : document.documentElement.clientWidth > 480
                    ? element.getBoundingClientRect().top - 260
                    : document.documentElement.clientWidth > 435
                      ? element.getBoundingClientRect().top - 260
                      : document.documentElement.clientWidth > 380
                        ? element.getBoundingClientRect().top - 270
                        : element.getBoundingClientRect().top - 290,
        behavior: 'smooth'
      })
    }
    if (lastelement) {
      lastelement.classList.remove('error-outlined-banner')
    }
  }

  updateErrorCount(nextPreviousButtonCalled: boolean, event: any) {
    if (event && event.srcElement.className != 'accordion__header') {
      setTimeout(() => {
        if (
          !nextPreviousButtonCalled &&
          this.isBannerShow &&
          this.isRedBannerShown &&
          this.editMode
        ) {
          this.outsideClick = false
          this.disableNextButton = false
          this.disablePrevButton = false
          const oldNumberOferrors = this.noOfErrors && this.noOfErrors.length
          this.noOfErrors = document.querySelectorAll('.outline-red')
            ? document.querySelectorAll('.outline-red')
            : ''
          const focussedElement: any = document.getElementsByClassName('error-outlined-banner')
            ? document.getElementsByClassName('error-outlined-banner')
            : ''
          const activeElement: any = document.activeElement
          if (focussedElement[0] && focussedElement[0] != activeElement) {
            focussedElement[0].classList.remove('error-outlined-banner')
          }
          if (
            activeElement &&
            activeElement != document.body &&
            (Object.entries(this.noOfErrors).find((x) => x[1] == activeElement) ||
              Object.entries(this.noOfErrors).find(
                (x) => x[1] == activeElement.parentElement.parentElement.previousSibling
              ))
          ) {
            if (activeElement.type == 'text') {
              activeElement.classList.add('error-outlined-banner')
              activeElement && activeElement.focus()
              window.scrollBy({
                top:
                  document.documentElement.clientWidth > 992
                    ? activeElement.getBoundingClientRect().top - 210
                    : document.documentElement.clientWidth > 830
                      ? activeElement.getBoundingClientRect().top - 230
                      : document.documentElement.clientWidth > 768
                        ? activeElement.getBoundingClientRect().top - 260
                        : document.documentElement.clientWidth > 580
                          ? activeElement.getBoundingClientRect().top - 260
                          : document.documentElement.clientWidth > 480
                            ? activeElement.getBoundingClientRect().top - 260
                            : document.documentElement.clientWidth > 435
                              ? activeElement.getBoundingClientRect().top - 260
                              : document.documentElement.clientWidth > 380
                                ? activeElement.getBoundingClientRect().top - 270
                                : activeElement.getBoundingClientRect().top - 290,
                behavior: 'smooth'
              })
            } else {
              this.outsideClick = true
            }
          } else {
            this.outsideClick = true
          }

          for (let index = 0; index < this.noOfErrors.length; index++) {
            if (this.noOfErrors[index] == focussedElement[0]) {
              this.positionofError = index + 1
            }
          }
          if (this.outsideClick && activeElement.type != 'text') {
            if (
              oldNumberOferrors > this.noOfErrors.length &&
              this.noOfErrors.length < this.positionofError
            ) {
              const differenceBtwErrors = oldNumberOferrors - this.noOfErrors.length
              const currentPosition = this.positionofError - differenceBtwErrors
              this.positionofError = currentPosition <= 0 ? APP_CONST.ONE : currentPosition + 1
            }
            const element: any = this.noOfErrors[this.positionofError - 1]
            const lastelement: any = this.noOfErrors[this.positionofError - 2]
            if (element) {
              this.isRedBannerShown = true
              element.classList.add('error-outlined-banner')
              if (
                (element && element.className == 'scholar outline-red error-outlined-banner') ||
                (element &&
                  element.className == 'scholar outline-red postal-input error-outlined-banner')
              ) {
                this.scholarInfoActive = true
              }

              if (
                (element && element.className == 'guardianAcc outline-red error-outlined-banner') ||
                (element &&
                  element.className == 'guardianAcc outline-red postal-input error-outlined-banner')
              ) {
                this.gaurdiansActive = true
              }
              if (
                element &&
                element.className == 'emergencyAcc outline-red error-outlined-banner'
              ) {
                this.emergencyIsActive = true
              }
              setTimeout(() => {
                element && element.focus()
              }, 100)
              window.scrollBy({
                top:
                  document.documentElement.clientWidth > 992
                    ? element.getBoundingClientRect().top - 210
                    : document.documentElement.clientWidth > 830
                      ? element.getBoundingClientRect().top - 230
                      : document.documentElement.clientWidth > 768
                        ? element.getBoundingClientRect().top - 260
                        : document.documentElement.clientWidth > 580
                          ? element.getBoundingClientRect().top - 260
                          : document.documentElement.clientWidth > 480
                            ? element.getBoundingClientRect().top - 260
                            : document.documentElement.clientWidth > 435
                              ? element.getBoundingClientRect().top - 260
                              : document.documentElement.clientWidth > 380
                                ? element.getBoundingClientRect().top - 270
                                : element.getBoundingClientRect().top - 290,
                behavior: 'smooth'
              })

              if (lastelement) {
                lastelement.classList.remove('error-outlined-banner')
              }
            } else if (!element && lastelement) {
              this.isRedBannerShown = true
              lastelement && lastelement.classList.add('error-outlined-banner')
              lastelement && lastelement.focus()
              window.scrollBy({
                top:
                  document.documentElement.clientWidth > 992
                    ? lastelement.getBoundingClientRect().top - 210
                    : document.documentElement.clientWidth > 830
                      ? lastelement.getBoundingClientRect().top - 230
                      : document.documentElement.clientWidth > 768
                        ? lastelement.getBoundingClientRect().top - 260
                        : document.documentElement.clientWidth > 580
                          ? lastelement.getBoundingClientRect().top - 260
                          : document.documentElement.clientWidth > 480
                            ? lastelement.getBoundingClientRect().top - 260
                            : document.documentElement.clientWidth > 435
                              ? lastelement.getBoundingClientRect().top - 260
                              : document.documentElement.clientWidth > 380
                                ? lastelement.getBoundingClientRect().top - 270
                                : lastelement.getBoundingClientRect().top - 290,
                behavior: 'smooth'
              })
              this.positionofError = this.positionofError - 1
            }
          }
          if (this.positionofError == this.noOfErrors.length) {
            this.disableNextButton = true
          }
          if (this.positionofError == APP_CONST.ONE) {
            this.disablePrevButton = true
          }
        }
        this.outsideClick = false
        this.nextPreviousButtonCalled = false
      }, 300)
    }
  }
}
